
import React, { FC } from 'react';
import { FontAwesomeIcon, FontAwesomeIcons } from '../../../constants/fontAwesomeIcons';
import { useHelpDrawer } from '../../../contexts/HelpDrawerContext';

import './HelpButton.scss';

const HelpButton: FC = () => {

    const { isOpen, setIsOpen } = useHelpDrawer();

    const rippleEffect = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        let ripple = document.createElement("span");
        ripple.classList.add("ripple");
        event.currentTarget.appendChild(ripple);

        setTimeout(() => {
            ripple.remove();
        }, 300);
    };

    const handleOnClickEvent: React.MouseEventHandler<HTMLButtonElement> = (
        event
    ) => {
        rippleEffect(event);
        setIsOpen(!isOpen)
    };

    return (
        <button
            className="help-button help-button-transition"
            aria-label={isOpen ? "Close help" : "Open help"}
            aria-expanded={isOpen}
            aria-controls="help-drawer"
            onClick={handleOnClickEvent}
            type="button"
        >
            <FontAwesomeIcon 
                className="help-button-icon"
                icon={FontAwesomeIcons.Duotone.CIRCLEQUESTION} 
                fixedWidth
            /> 
        </button>
    );
}


export default HelpButton;
